import React from 'react';
import { cn } from 'lib/utils';
import propTypes from 'prop-types';

export default function SidebarContent({
  children,
  className,
  showScrollbar = false,
  includesHeader = false,
  dataTour
}) {
  return (
    <div
      data-tour={dataTour}
      className={cn(
        'flex flex-col h-full min-h-0 bg-white p-4 gap-4 overflow-y-auto',
        includesHeader ? 'rounded-b-xl' : 'rounded-xl',
        showScrollbar && 'show-scrollbar',
        className
      )}
    >
      {children}
    </div>
  );
}

SidebarContent.propTypes = {
  children: propTypes.node.isRequired,
  className: propTypes.string,
  showScrollbar: propTypes.bool,
  includesHeader: propTypes.bool,
  dataTour: propTypes.string
};
